module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    class: ['spinner spinner-gritcode', _vm.spinnerSize, {
      'spinner-fixed': _vm.fixed
    }]
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('div', {
    staticClass: "spinner-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-text"
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d9160f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/Spinner.vue
// module id = 896
// module chunks = 0